import {
  Grid,
  FormControl,
  Box,
  Typography,
  Chip,
  Tooltip,
} from "@mui/material";
import { useState } from "react";
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import EditIcon from "@mui/icons-material/Edit";
import CommonDatePicker from "../../../../Base/views/CommonDatePicker";
import MaterialTable from "material-table";
import {
  ConvertDate,
  ConvertTime,
  DateConvertInDbFormat,
  getEmployeeId,
} from "../../../../Base/helper/baseFunctions";
import BackdropMeepl from "../../../../Ancillary/AnimationComponents/BackdropMeepl";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import CommentIcon from "@mui/icons-material/Comment";
import {
  GetMyAttendanceRegularizationAction,
  UpsertMyAttendanceRegularizationAction,
  DeleteMyAttendanceRegularizationAction,
} from "../../../../../../store/Leave/Regularization/Action";
import Popup from "../../../../Base/views/Popup";
import RaiseRegularizationPopup from "./RaiseRegularizationPopup";

const MyRegularization = () => {
  const dispatch = useDispatch();
  const date = new Date();
  const { isLoading, my_attendance_regularization } = useSelector(
    (state) => state?.LeaveReducer?.MyAttendanceRegularizationReducer,
  );
  const { minDojYear } = useSelector(
    (state) => state?.AncillaryReducer?.WorkSpaceDojReducer,
  );
  const [filters, setFilters] = useState({
    month_year: `${date?.getFullYear()}-${
      date?.getMonth() + 1
    }-${date?.getDate()}`,
    ats_work_location_id: [],
  });
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogMode, setDialogMode] = useState("add");
  const [dialogRowData, setDialogRowData] = useState(null);

  const [f_year, f_month] = filters.month_year.split("-");
  const startOfMonth = new Date(f_year, f_month - 1, 1);
  const endOfMonth = new Date(f_year, f_month, 0);

  const formatDataStructure = (data) => {
    if (!data || data.length === 0) return [];

    return data?.map((employee) => {
      return {
        ...employee,
        record_date: employee?.in_date,
        check_in_time: employee?.in_time,
        check_out_time: employee?.out_time,
      };
    });
  };
  const employeeRegularizationRows =
    formatDataStructure(my_attendance_regularization) || [];
  const fetchData = () => {
    const [f_year, month] = filters.month_year.split("-");
    const f_month = parseInt(month, 10).toString();
    dispatch(
      GetMyAttendanceRegularizationAction({
        month: f_month,
        year: f_year,
        tab: "Self",
      }),
    );
  };
  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters]);

  const openRegularizationDialog = (mode, row = null) => {
    if (mode === "edit" && row) {
      setDialogRowData(row);
    } else {
      setDialogRowData(null);
    }
    setDialogMode(mode);
    setDialogOpen(true);
  };

  const handleSubmitRowData = (rowData, actionType) => {
    const [f_year, month] = filters.month_year.split("-");
    const f_month = parseInt(month, 10).toString();
    const checkIn = getAttendanceDateTime(rowData?.check_in_time);
    const checkOut = getAttendanceDateTime(rowData?.check_out_time);
    if (actionType === "edit" && rowData?.attendance_regularisation_pk) {
      dispatch(
        UpsertMyAttendanceRegularizationAction(
          {
            ...rowData,
            employee_fk: getEmployeeId(),
            month: f_month,
            year: f_year,
            in_date: checkIn.date,
            out_date: checkOut.date,
            in_time: checkIn.time,
            out_time: checkOut.time,
            attendance_regularisation_pk: rowData?.attendance_regularisation_pk,
            tab: "Self",
            status:
              rowData?.status === "Rejected" ? "Submitted" : rowData?.status,
            actionType,
          }
        ),
      );
    } else if (actionType === "add") {
      const checkIn = getAttendanceDateTime(rowData?.check_in_time);
      const checkOut = getAttendanceDateTime(rowData?.check_out_time);
      dispatch(
        UpsertMyAttendanceRegularizationAction(
          {
            employee_fk: getEmployeeId(),
            month: f_month,
            year: f_year,
            in_date: checkIn.date,
            out_date: checkOut.date,
            in_time: checkIn.time,
            out_time: checkOut.time,
            attendance_regularisation_pk: null,
            tab: "Self",
            status: "Submitted",
            actionType,
          }
        ),
      );
    } else if (actionType === "delete") {
      dispatch(
        DeleteMyAttendanceRegularizationAction(
          {
            attendance_regularisation_pk:
              rowData?.attendance_regularisation_pk,
            month: f_month,
            year: f_year,
            tab: "Self",
            logged_in_employee_fk: getEmployeeId()
          }
        ),
      );
    } else {
      console.log("Invalid action type:", actionType);
    }
  };

  const handleFilter = (event, value) => {
    if (["month_year"].includes(event?.target?.name)) {
      setFilters({ ...filters, [event?.target?.name]: event?.target?.value });
    }
  };
  const titleContent = (
    <Box>
      <Typography variant="h6" fontWeight={600}>
        My Attendance Regularizations
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Review your attendance records and submit regularization requests to
        correct missing or inaccurate punch times.
      </Typography>
    </Box>
  );
  return (
    <Box
      sx={{
        maxHeight: "calc(100vh - 85px)",
        overflowY: "auto",
      }}
    >
      <Grid py={1} container alignItems="center">
        <Grid item>
          <FormControl>
            <CommonDatePicker
              name="month_year"
              openTo="month"
              views={["year", "month"]}
              label="Month and Year"
              pickerType="date"
              size="small"
              onKeyDown={(e) => e.preventDefault()}
              onKeyPress={(e) => e.preventDefault()}
              pickerFormat="MM/yyyy"
              DefaultDTvalue={filters.month_year}
              maxDate={new Date()}
              minDate={
                new Date(
                  new Date(minDojYear).setFullYear(
                    new Date(minDojYear).getFullYear() - 1,
                  ),
                )
              }
              handleChange={(value) =>
                handleFilter({
                  target: {
                    name: "month_year",
                    value: value
                      ? `${value?.getFullYear()}-${(
                          "0" +
                          (value?.getMonth() + 1)
                        ).slice(-2)}-${("0" + value?.getDate()).slice(-2)}`
                      : "",
                  },
                })
              }
            />
          </FormControl>
        </Grid>
      </Grid>
      <Box sx={{ position: "relative" }}>
        <MaterialTable
          isLoading={isLoading}
          key={filters?.month_year}
          columns={[
            {
              title: "Date",
              headerStyle: {
                maxWidth: 150,
                minWidth: 150,
                padding: "5px 0px 5px 5px",
                textAlign: "start",
              },
              cellStyle: {
                maxWidth: 150,
                minWidth: 150,
                textAlign: "start",
                padding: "5px 0px 5px 5px",
              },
              field: "record_date",
              grouping: false,
              render: (rowData) =>
                rowData?.record_date ? ConvertDate(rowData?.record_date) : "",
            },
            {
              field: "check_in_time",
              title: "Check-In Time",
              headerStyle: {
                maxWidth: 175,
                minWidth: 175,
                padding: "5px 0px 5px 5px",
                textAlign: "start",
              },
              cellStyle: {
                maxWidth: 175,
                minWidth: 175,
                textAlign: "start",
                padding: "5px 0px 5px 5px",
              },
              render: (rowData) => ConvertTime(rowData?.check_in_time, true) || "",
            },
            {
              field: "check_out_time",
              title: "Check-Out Time",
              headerStyle: {
                maxWidth: 190,
                minWidth: 190,
                padding: "5px 0px 5px 25px",
                textAlign: "start",
              },
              cellStyle: {
                maxWidth: 190,
                minWidth: 190,
                textAlign: "start",
                padding: "5px 0px 5px 25px",
              },
              render: (rowData) => ConvertTime(rowData?.check_out_time, true) || "",
            },
            {
              field: "status",
              title: "Status",
              editable: "never",
              headerStyle: {
                maxWidth: 130,
                minWidth: 130,
                padding: "5px 0px 5px 5px",
                textAlign: "end",
              },
              cellStyle: {
                maxWidth: 130,
                minWidth: 130,
                textAlign: "end",
                padding: "5px 0px 5px 5px",
              },
              render: (rowData) => {
                const { bg, text } = getStatusColor(rowData?.status);
                return (
                  <Chip
                    label={rowData.status}
                    style={{
                      backgroundColor: bg,
                      color: text,
                      fontWeight: 500,
                    }}
                    size="small"
                  />
                );
              },
            },
            {
              field: "comments",
              title: "Approver Comment",
              editable: "never",
              headerStyle: {
                maxWidth: 110,
                minWidth: 110,
                padding: "5px 0px 5px 5px",
                textAlign: "center",
              },
              cellStyle: {
                maxWidth: 110,
                minWidth: 110,
                textAlign: "center",
                padding: "5px 0px 5px 5px",
              },
              sorting: false,
              render: (rowData) => {
                return (
                  <Box width={"90%"}>
                    <Tooltip title={rowData?.comments || ""} arrow>
                      <CommentIcon
                        sx={{
                          fontSize: "20px",
                          color: rowData?.comments ? "#637381" : "#95a0ab",
                          cursor: rowData?.comments ? "pointer" : "default",
                        }}
                      />
                    </Tooltip>
                  </Box>
                );
              },
            },
          ]}
          data={employeeRegularizationRows || []}
          options={{
            maxBodyHeight: "calc(100vh - 290px)",
            minBodyHeight: "calc(100vh - 290px)",
            rowStyle: { fontSize: "13px", height: "30px" },
            headerStyle: {
              padding: "7px 0px 7px 0px",
              fontWeight: "bold",
            },
            sorting: true,
            search: true,
            searchText: "",
            searchFieldAlignment: "right",
            searchAutoFocus: false,
            searchFieldVariant: "standard",
            filtering: false,
            paging: true,
            pageSizeOptions: [25, 50],
            pageSize: 25,
            paginationType: "stepped",
            showFirstLastPageButtons: false,
            paginationPosition: "bottom",
            exportButton: false,
            exportAllData: false,
            addRowPosition: "first",
            selection: false,
            actionsColumnIndex: -1,
            showSelectAllCheckbox: false,
            showTextRowsSelected: false,
            grouping: false,
            columnsButton: false,
          }}
          actions={[
            {
              icon: () => <AddIcon sx={{ color: "#637381" }} />,
              tooltip: "Add Regularization",
              isFreeAction: true,
              onClick: () => openRegularizationDialog("add"),
            },
            (rowData) => ({
              icon: () => <EditIcon sx={{ color: rowData?.status !== "Rejected" ? "#bdbdbd" : "#637381" }}  />,
              tooltip: rowData?.status !== "Rejected" ? "" : "Edit",
              onClick: (event, rowData) => openRegularizationDialog("edit", rowData),
              disabled: rowData?.status !== "Rejected"
            }),
          ]}
          icons={{
            Delete: (props) => (
              <DeleteIcon
                sx={{ color: props?.disabled ? "#bdbdbd" : "#637381" }}
              />
            ),
          }}
          editable={{
            isDeletable: (rowData) => rowData?.status === "Rejected",
            onRowDelete: (selectedRow) =>
              new Promise((resolve, reject) => {
                handleSubmitRowData(selectedRow, "delete");
                setTimeout(() => resolve(), 1000);
              }),
          }}
          components={{
            Overlay: () => null,
            OverlayLoading: () => <BackdropMeepl open={true} dark={false} />,
          }}
          title={titleContent}
        />

        <Popup
          title={dialogMode === "edit"
            ? "Edit Attendance Regularization"
            : "Add Attendance Regularization"}
          openPopup={dialogOpen}
          setOpenPopup={setDialogOpen}
        >
          <RaiseRegularizationPopup
            editedRecord={dialogRowData}
            setOpenPopup={setDialogOpen}
            onSubmit={(data) => {
              handleSubmitRowData(data, dialogMode);
            }}
            addMode={dialogMode === "edit"}
            startOfMonth={startOfMonth}
            endOfMonth={endOfMonth}
          />
        </Popup>
      </Box>
    </Box>
  );
};

const getStatusColor = (status) => {
  switch (status) {
    case "Pending Approval":
      return { bg: "#FFF4E5", text: "#FFA726" }; // yellow
    case "Approved":
      return { bg: "#E8F5E9", text: "#66BB6A" }; // green
    case "Rejected":
      return { bg: "#FFEBEE", text: "#EF5350" }; // red
    case "Submitted":
      return { bg: "#E3F2FD", text: "#42A5F5" };
    default:
      return { bg: "#E5E7EB", text: "#374151" }; // gray
  }
};

const getLocalISOString = (date) => {
  if (!date) return null;

  const offsetInMinutes = date?.getTimezoneOffset();
  const localTime = new Date(date.getTime() - offsetInMinutes * 60000);

  return localTime.toISOString().slice(0, -1);
};
const getAttendanceDateTime = (value) => {
  if (!value) {
    return {
      date: null,
      time: null,
    };
  }
  // Existing record from DB
  if (typeof value === "string") {
    return {
      date: value.split("T")[0],
      time: value,
    };
  }
  // User modified value in DateTimePicker
  if (value instanceof Date) {
    return {
      date: DateConvertInDbFormat(value),
      time: getLocalISOString(value),
    };
  }
  return {
    date: null,
    time: null,
  };
};
export default MyRegularization;
